module.exports = __webpack_public_path__ + "static/media/step_detail_career_van_tai_mobile.d2ba53d7.jpg";